import React, 
       { useState, 
         useEffect, 
         useRef }                           from "react";
import   ReactDOM                           from 'react-dom';
import { useLoader                   }      from "components/Covers/loadingCover";
import { useInfoMsgModal}                   from "components/Covers/infoMessageModal";
import { useToastMessage             }      from "components/Covers/toastMessage";
import { InputGeneral                }      from "components/Field/field";
import { DatePicker,
         DateTimePicker,
         DateToIsoString,
         DateFromIsoString,
         InitDateToIsoString,
         InitDateFromIsoString,
         FinDateToIsoString,
         FinDateFromIsoString,
         setDefaultInitDate,
         setDefaultFinalDate,
         compareInitFinDate,
         DateToString                 }     from "components/Date/date";
import  MainStyle                           from "components/UI/main.module.scss";
import { useNavigate                  }     from "react-router-dom";
// BEGIN AG AGRID
import { AgGridReact                  }     from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import { AG_GRID_LOCALE_BR            }     from '@ag-grid-community/locale';
import { Select                       }     from "antd";
import { useFilter                    }     from "components/Menu/menu";
import { DefaultLoadingLogo,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature               }     from "Utilities/utils";
import { DisplayGridDatetime          }     from "components/Date/date";
import { getOrdersList, 
         getFilterMeta,
         getUserTag,
         UpdateOrderTag,
         getOrderSpreadSheet          }     from "./Report_0_Service";
import { AggregatedReportDocument     }     from "components/OrderDocument/orderDocumentRes";
import { OrderDocumentPreview         }     from "components/OrderDocument/orderDocumentPreview";
import { AggregatedReport             }     from "components/OrderAggregatedReport/orderAggregatedReport";
import dayjs                                from "dayjs";
import Draggable                            from 'react-draggable';
import { Resizable                    }     from 're-resizable';

const MAX_SELECTED_ROWS = 20;

// #region Object Template
let blank_search_param_obj = {
    STATUS_IDS        : [4,5],
    DT_INIT           : DateToIsoString(setDefaultInitDate()),
    DT_FN             : DateToIsoString(setDefaultFinalDate()),
    SCHOOL_IDS        : [],
    AREA_IDS          : [],
    PROGRAM_IDS       : [],
    CLIENT_IDS        : [],
    ACADEMIC_AREA_IDS : [],
    USER_IDS          : [],
    FILTER_TAG        : true,
};
let blank_meta_param_obj = {
    SCHOOL_LIST       : [],
    AREA_LIST         : [],
    PROGRAM_LIST      : [],
    CLIENT_LIST       : [],
    ACADEMIC_AREA_LIST: [],
    USER_IDS          : []
};
let appLang = null;
// #endregion

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_lg, MainStyle.border_bottom].join(" ")}/>
                </div>
            </div>
        </>
    );
};
//#endregion

// #region Filter Data
const FilterBtnRemoveItem = React.memo(({clickAction}) => {
    return (
        <div 
            onClick={clickAction}
            className={[MainStyle.py_1].join(" ")}
        >
            <div className={[MainStyle.d_flex].join(" ")}>
                <svg
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 384 512"
                    style={{width: '0.8rem', height: '0.8rem'}}
                    className={[MainStyle.close_icon].join(" ")} 
                >
                    <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                </svg>
            </div>
        </div>
    );
});
const FilterStatusList = React.memo(({...other}) => {
    const { statusList,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = statusList.find((status) => status.value === d);
        return found ? found.label : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.STATUS_IDS.filter(item => item !== d);
            return {
                ...prevState,
                STATUS_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.STATUS_IDS?.map((status, i) => {
                    return (
                        <div key={`status_list_${status}${i}`} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(status)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(status)}
                                </span>
                            </div>
                        </div>
                    )
                }
            )}
        </>
    );
});
const FilterSchoolList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.SCHOOL_LIST.find((item) => item.SCHOOL_ID === d);
        return found ? found.SCHOOL_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.SCHOOL_IDS.filter(item => item !== d);
            return {
                ...prevState,
                SCHOOL_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.SCHOOL_IDS?.map((item, i) => {
                    return (
                        <div key={`school_list_${item}${i}`} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>
                    )
                }
            )}
        </>
    );
});
const FilterAreaList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.AREA_LIST.find((item) => item.AREA_ID === d);
        return found ? found.AREA_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.AREA_IDS.filter(item => item !== d);
            return {
                ...prevState,
                AREA_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.AREA_IDS?.map((item, i) => {
                    return (
                        <div key={`area_list_${item}${i}`} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>
                    )
                }
            )}
        </>
    );
});
const FilterProgramList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;

    function getLabelValue(d) {
        const found = searchMetaParam.PROGRAM_LIST.find((item) => item.PROGRAM_ID === d);
        return found ? found.PROGRAM_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.PROGRAM_IDS.filter(item => item !== d);
            return {
                ...prevState,
                PROGRAM_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.PROGRAM_IDS?.map((item, i) => {
                    return (
                        <div key={`program_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                       
                    )
                }
            )}
        </>
    );
});
const FilterClientList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.CLIENT_LIST.find((item) => item.CLIENT_ID === d);
        return found ? found.CLIENT_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.CLIENT_IDS.filter(item => item !== d);
            return {
                ...prevState,
                CLIENT_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.CLIENT_IDS?.map((item, i) => {
                    return (
                        <div key={`client_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterAcademicAreaList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.ACADEMIC_AREA_LIST.find((item) => item.ACADEMIC_AREA_ID === d);
        return found ? found.ACADEMIC_AREA_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.ACADEMIC_AREA_IDS.filter(item => item !== d);
            return {
                ...prevState,
                ACADEMIC_AREA_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.ACADEMIC_AREA_IDS?.map((item, i) => {
                    return (
                        <div key={`program_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterUsersList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.USER_LIST.find((item) => item.USER_ID === d);
        return found ? found.FULL_NAME : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.USER_IDS.filter(item => item !== d);
            return {
                ...prevState,
                USER_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.USER_IDS?.map((item, i) => {
                    return (
                        <div key={`users_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterOptions = React.memo(({...props}) => {
    const { setRowData,
            searchMetaParam,
            searchParam,
            setSearchParam  }      = props;
    const { showInfoMessage }      = useInfoMsgModal();
    const { showLoader, 
            hideLoader      }      = useLoader();

    async function startSearch() {
        if (!compareInitFinDate(searchParam.DT_INIT, searchParam.DT_FN)) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230)});
            return;
        }
        if (searchParam?.STATUS_IDS?.length == 0) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 521)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let data = await getOrdersList(searchParam);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                let arr = [];
                for(var j = 0; j < data.length; j++) {
                    arr.push(data[j]);
                }
                setRowData(arr);
                hideLoader();
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
    }

    useEffect(() => {

    },[searchMetaParam, searchParam]);

    const statusList                             =  [{value: 4, label: GetLabel(appLang, 40)},
                                                     {value: 5, label: GetLabel(appLang, 97)},
                                                     {value: 6, label: GetLabel(appLang, 232)}];

    
    return(
        <>
            <div className={[MainStyle.overflow_y_scroll].join(" ")}>
                {/*         Tag            */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={MainStyle.mx_3}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 532)}
                                            </span>                      
                                            <input
                                                type="checkbox"
                                                name={"read"}
                                                value={searchParam?.FILTER_TAG}
                                                checked={searchParam?.FILTER_TAG}
                                                onChange={()=> {
                                                    searchParam?.FILTER_TAG === false ?                                                             
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                FILTER_TAG: true
                                                            }))
                                                        : 
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                FILTER_TAG: false
                                                            }))
                                                }}
                                                style={{ transform: "scale(1.5)" }}
                                                disabled={false}
                                                className={MainStyle.mx_3}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*         Status        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 37)}
                                            </span>                      
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 233)}
                                                listOfItems={statusList}
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.STATUS_IDS.some((s) => s === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            STATUS_IDS: [...prevState.STATUS_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterStatusList statusList={statusList} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*         School        */}
                {searchMetaParam?.SCHOOL_LIST?.length > 0 && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 318)}
                                                </span>
                                                <DropdownList
                                                    value={null}
                                                    placeholder={GetLabel(appLang, 379)}
                                                    listOfItems={ 
                                                        searchMetaParam?.SCHOOL_LIST?.map((i) => (
                                                                {value: i.SCHOOL_ID, label: i.SCHOOL_DESC}
                                                            ))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(event) => {
                                                        if (searchParam.SCHOOL_IDS.some((i) => i === event)) {
                                                            return;
                                                        }
                                                        else {
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                SCHOOL_IDS: [...prevState.SCHOOL_IDS, event]
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <FilterSchoolList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                )}
                {/*          Area         */}
                {searchMetaParam?.AREA_LIST?.length > 0 && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 319)}
                                                </span>
                                                <DropdownList
                                                    value={null}
                                                    placeholder={GetLabel(appLang, 380)}
                                                    listOfItems={ 
                                                        searchMetaParam?.AREA_LIST?.map((i) => (
                                                                {value: i.AREA_ID, label: i.AREA_DESC}
                                                            ))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(event) => {
                                                        if (searchParam.AREA_IDS.some((i) => i === event)) {
                                                            return;
                                                        }
                                                        else {
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                AREA_IDS: [...prevState.AREA_IDS, event]
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <FilterAreaList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                )}                    
                {/*        Program        */}
                {searchMetaParam?.PROGRAM_LIST?.length > 0 && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 321)}
                                                </span>
                                                <DropdownList
                                                    value={null}
                                                    placeholder={GetLabel(appLang, 381)}
                                                    listOfItems={ 
                                                        searchMetaParam?.PROGRAM_LIST?.map((i) => (
                                                                {value: i.PROGRAM_ID, label: i.PROGRAM_DESC}
                                                            ))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(event) => {
                                                        if (searchParam.PROGRAM_IDS.some((i) => i === event)) {
                                                            return;
                                                        }
                                                        else {
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                PROGRAM_IDS: [...prevState.PROGRAM_IDS, event]
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <FilterProgramList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/*        Client         */}
                {searchMetaParam?.CLIENT_LIST?.length > 0 && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 322)}
                                                </span>
                                                <DropdownList
                                                    value={null}
                                                    placeholder={GetLabel(appLang, 382)}
                                                    listOfItems={ 
                                                        searchMetaParam?.CLIENT_LIST?.map((i) => (
                                                                {value: i.CLIENT_ID, label: i.CLIENT_DESC}
                                                            ))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(event) => {
                                                        if (searchParam.CLIENT_IDS.some((i) => i === event)) {
                                                            return;
                                                        }
                                                        else {
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                CLIENT_IDS: [...prevState.CLIENT_IDS, event]
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <FilterClientList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                )}
                {/*     Academic Area     */}
                {searchMetaParam?.ACADEMIC_AREA_LIST?.length > 0 && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 323)}
                                                </span>
                                                <DropdownList
                                                    value={null}
                                                    placeholder={GetLabel(appLang, 522)}
                                                    listOfItems={ 
                                                        searchMetaParam?.ACADEMIC_AREA_LIST?.map((i) => (
                                                                {value: i.ACADEMIC_AREA_ID, label: i.ACADEMIC_AREA_DESC}
                                                            ))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(event) => {
                                                        if (searchParam.ACADEMIC_AREA_IDS.some((i) => i === event)) {
                                                            return;
                                                        }
                                                        else {
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                ACADEMIC_AREA_IDS: [...prevState.ACADEMIC_AREA_IDS, event]
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <FilterAcademicAreaList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                )}
                {/*         Users         */}
                {searchMetaParam?.USER_LIST?.length > 0 && (
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 81)}
                                                </span>
                                                <DropdownList
                                                    value={null}
                                                    placeholder={GetLabel(appLang, 286)}
                                                    listOfItems={ 
                                                        searchMetaParam?.USER_LIST?.map((i) => (
                                                                {value: i.USER_ID, label: i.FULL_NAME}
                                                            ))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(event) => {
                                                        if (searchParam.USER_IDS.some((i) => i === event)) {
                                                            return;
                                                        }
                                                        else {
                                                            setSearchParam(prevState => ({
                                                                ...prevState,
                                                                USER_IDS: [...prevState.USER_IDS, event]
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <FilterUsersList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                )}                                       
                {/*         DT Init       */}         
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 523)}
                                </span>                      
                                <DatePicker
                                    value={InitDateFromIsoString(searchParam.DT_INIT)}
                                    placeholder={GetLabel(appLang, 487)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_INIT: DateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*         DT Fin        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 524)}
                                </span>
                                <DatePicker
                                    value={FinDateFromIsoString(searchParam.DT_FN)}
                                    placeholder={GetLabel(appLang, 488)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_FN: DateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_green, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {startSearch();}}
                        >
                            {GetLabel(appLang, 238)}
                        </button>
                    </div>
                </div>                            
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {
                                setSearchParam(blank_search_param_obj);
                            }}
                        >
                            {GetLabel(appLang, 239)}
                        </button>
                    </div>
                </div>                            
            </div>
        </>
    );

});
// #endregion

// #region Tag Data
const isMobileOrTablet = () => {
    const userAgent = navigator.userAgent || window.opera;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return /android|ipad|iphone|ipod/i.test(userAgent) || (isTouch && isSmallScreen);
};

const Tag = ({...other}) => {
    const { tagDataset, 
            tagId, 
            tagColor, 
            tagDesc, 
            orderIdTag, 
            setRowData, 
            setTagVisible               }   = other;
    const { showToastMessage            }   = useToastMessage();
    
    async function handleClick() {
        let data = await UpdateOrderTag(orderIdTag, tagId);
        if (data) {
            if (data?.status?.statusCode == 0) {
                showToastMessage({
                    'header': GetLabel(appLang, 54), 
                    'message': `${GetLabel(appLang, 533)} ${tagDesc} ${GetLabel(appLang, 534)}`
                });
                let tag_data = null;
                for (let i = 0; i < tagDataset.length; i++) {
                    if(tagDataset[i].TAG_ID === tagId) {
                        tag_data = tagDataset[i];
                        break;
                    }
                }
                if (tag_data) {
                    setRowData((prev) =>
                        prev.map((row) => {
                            if (row.ORDER_ID === orderIdTag) {
                                return {
                                    ...row,
                                    TAG_DESC: tag_data.TAG_DESC,
                                    TAG_COLOR: tag_data.TAG_COLOR,
                                };
                            } else {
                                return { ...row };
                            }
                        })
                    );
                    setTagVisible(false);
                }
            }
            else if (data?.status?.statusCode == -10) {
                showToastMessage({
                    'header': GetLabel(appLang, 54), 
                    'message': `${GetLabel(appLang, 535)} ${tagDesc}.`
                });
                setRowData((prev) =>
                    prev.filter((row) => row.ORDER_ID !== orderIdTag)
                );
                setTagVisible(false);                
            }
            else {
                showToastMessage({
                    'header': GetLabel(appLang, 54), 
                    'message': GetLabel(appLang, 531)
                });
                setTagVisible(false);
            }
        }
        else {
            showToastMessage({
                'header': GetLabel(appLang, 54), 
                'message': GetLabel(appLang, 531)
            });
        }
    }

    useEffect(() => {}, [tagDataset, tagId, tagColor, tagDesc, orderIdTag, setRowData, setTagVisible]);

    return (
        <div 
            id={tagId} 
            orderid={orderIdTag}
            className={[MainStyle.row, 
                        MainStyle.clickable, 
                        MainStyle.sidebar_btn_tag_generic, 
                        MainStyle.py_2].join(" ")}
            onClick={() => {handleClick();}}
        >
        <div className={MainStyle.col_2}>
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 448 512"
                className={MainStyle.sidebar_btn_ico_tag_generic}
                style={{ fill: tagColor }}
            >
                <path d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
            </svg>
            </div>              
        </div>
        <div className={MainStyle.col_10}>
            <div className={[MainStyle.text_start, MainStyle.text_body].join(" ")}>
            <span className={[MainStyle.fs_6].join(" ")}>{tagDesc}</span>
            </div>
        </div>            
        </div>
    );
};

const TagPanel = ({...other}) => {
    const {tagDataset, tagVisible, setTagVisible, tagPosition, orderIdTag, setRowData} = other;
    const [ tagElements, setTagElements  ] = useState([]);

    useEffect(() => {
        if (tagDataset) {
            let jsxElement = [];
            for (let i = 0; i < tagDataset.length; i++) {
                jsxElement.push(
                    <Tag
                        key={tagDataset[i].TAG_ID}
                        tagId={tagDataset[i].TAG_ID}
                        tagColor={tagDataset[i].TAG_COLOR}
                        tagDesc={tagDataset[i].TAG_DESC}
                        setTagVisible={setTagVisible}
                        orderIdTag={orderIdTag}
                        setRowData={setRowData}
                        tagDataset={tagDataset}
                    />
                );
            }
            setTagElements(jsxElement);
        }
    }, [tagVisible, orderIdTag, tagDataset]); 

    if (!tagVisible) return null;

    const content = !isMobileOrTablet() ? 
        (<Draggable>
            <Resizable
                    style={{
                        position: 'fixed', // CRITICAL
                        top: tagPosition.y,
                        left: tagPosition.x,
                        zIndex: 10,
                    }}
                    className={[
                            MainStyle.rounded,
                            MainStyle.shadow,
                            MainStyle.border,
                            MainStyle.bg_theme
                    ].join(" ")}
            >
                <div 
                    style={{cursor: 'move'}} 
                    className={[MainStyle.bg_card,MainStyle.py_2, MainStyle.border_bottom].join(" ")}>
                    <div className={MainStyle.row}>
                        <div className={[MainStyle.col_11, MainStyle.align_self_end].join(" ")}>
                            <span className={[MainStyle.fs_5, MainStyle.text_body, MainStyle.mx_3].join(" ")}>
                                {GetLabel(appLang, 68)}
                            </span>
                        </div>
                        <div className={[MainStyle.col_1, MainStyle.align_self_end].join(" ")}>
                            <div onClick={() => setTagVisible(false)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 384 512"
                                    style={{width: '0.8rem', height: '0.8rem'}}
                                    className={[MainStyle.close_icon].join(" ")} 
                                >
                                    <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={[MainStyle.overflow_y_scroll, MainStyle.overflow_x_scroll].join(" ")}>
                    <div style={{width: '20rem', height: '20rem'}}>
                        {tagElements}
                    </div>
                </div>
            </Resizable>
        </Draggable>)
    :
        (<div
                style={{
                    position: 'fixed', // CRITICAL
                    top: tagPosition.y,
                    left: 10,
                    zIndex: 10,
                    width: 300, height: 400
                }}
                className={[
                        MainStyle.rounded,
                        MainStyle.shadow,
                        MainStyle.border,
                        MainStyle.bg_theme
                ].join(" ")}
        >
            <div
                className={[MainStyle.bg_card,MainStyle.py_2, MainStyle.border_bottom].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_11, MainStyle.align_self_end].join(" ")}>
                        <span className={[MainStyle.fs_5, MainStyle.text_body, MainStyle.mx_3].join(" ")}>
                            {GetLabel(appLang, 68)}
                        </span>
                    </div>
                    <div className={[MainStyle.col_1, MainStyle.align_self_end].join(" ")}>
                        <div onClick={() => setTagVisible(false)}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 384 512"
                                style={{width: '0.8rem', height: '0.8rem'}}
                                className={[MainStyle.close_icon].join(" ")} 
                            >
                                <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div className={[MainStyle.overflow_y_scroll, MainStyle.overflow_x_scroll].join(" ")}>
                <div style={{width: '20rem', height: '20rem'}}>
                    {tagElements}
                </div>
            </div>
                
        </div>)
    ;

    return ReactDOM.createPortal(content, document.body);
};
// #endregion


const OpenTag = ({  props,
                    setOrderIdTag,
                    setTagPosition,
                    setTagVisible   
                }) => {

    const handleClick = (e) => {
        if (props?.data?.ORDER_ID) {
            const clickX = e.clientX;
            const clickY = e.clientY;
            
            setOrderIdTag(props.data.ORDER_ID);
            setTagPosition({ x: clickX, y: clickY });
            setTagVisible(true);
        }
    };
    useEffect(() => {},[props]);
    return(
        <>
            <div 
                onClick={(e) => {handleClick(e);}}
                className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 576 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
                >
                    <path d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                </svg>
            </div>
        </>
    );
};

function downloadExcelFromBase64(base64) {
    const byteCharacters    = atob(base64);
    const byteNumbers       = new Array(byteCharacters.length);
    
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    
    const byteArray = new Uint8Array(byteNumbers);
    const blob      = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const blobUrl   = URL.createObjectURL(blob);

    const a         = document.createElement("a");
    a.href          = blobUrl;
    a.download      = `Survey_Exported_Sheet_${Date.now()}_${Math.floor(Math.random() * 32672)}.xlsx`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
}

const OrderTableGrid = React.memo(({...other}) => {
    const { setDataSet,
            setScreen,
            searchMetaParam,
            searchParam,
            setSearchParam,
            rowData,
            setRowData                  } = other;
    const [ searchText,  setSearchText  ] = useState('');      // Searched text state
    const [ columnDefs,  setcolumnDefs  ] = useState([]);      // State of columns def
    const gridRef                         = useRef();
    const { showInfoMessage             } = useInfoMsgModal(); // Modal message control 
    const { showFilter, hideFilter      } = useFilter();       // Control over the filter
    const { showLoader, hideLoader      } = useLoader();       // Control over the loader
    const { showToastMessage            } = useToastMessage();


    const [ tagDataset,  setTagDataset   ] = useState([]);
    const [ tagVisible,  setTagVisible   ] = useState(false);
    const [ tagPosition, setTagPosition  ] = useState({ x: 100, y: 100 }); // default fallback
    const [ orderIdTag,  setOrderIdTag   ] = useState(0); // default fallback
    

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true,
        rowSelection: { 
            mode: 'multiRow',
        },
    };
    
    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    const searchDataset = (t) => {
        // Method for free version
        const selectedRows = [];
        gridRef.current.api.forEachNodeAfterFilter(node => {
            if (node.isSelected()) {
                selectedRows.push(node.data);
            }
        });
        // Old method only works on paid version
        //const selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length == 0) {
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': GetLabel(appLang, 525)});
            return;
        }
        else if (selectedRows.length > MAX_SELECTED_ROWS) {
            showInfoMessage({ header: GetLabel(appLang, 107), 
                              message: <><span>{GetLabel(appLang, 536)}</span><br/><span>{GetLabel(appLang, 537)}</span></>
                            });
            return;
        }
        let arr = [];
        for (let i = 0; i < selectedRows.length; i++) {
            arr.push(selectedRows[i].ORDER_ID);
        }
        if (arr) {
            if (t === 1) {
                setDataSet(arr);
                hideFilter();
                setScreen(4);
            }
            else {
                setDataSet(arr);
                hideFilter();
                setScreen(5);
            }
        }
    };

    async function handleSpreadSheetFetch(arr) {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let data = await getOrderSpreadSheet(arr);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                downloadExcelFromBase64(data.DATA); 
                hideLoader();
                showToastMessage({
                    'header': GetLabel(appLang, 54), 
                    'message': GetLabel(appLang, 538)
                });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
        else {
            hideLoader();
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
        }
    };    

    function getSelectedRows() {
        // Method for free version
        const selectedRows = [];
        gridRef.current.api.forEachNodeAfterFilter(node => {
            if (node.isSelected()) {
                selectedRows.push(node.data);
            }
        });
        // Old method only works on paid version
        //const selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length == 0) {
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': GetLabel(appLang, 525)});
            return;
        }
        else if (selectedRows.length > MAX_SELECTED_ROWS) {
            showInfoMessage({ header: GetLabel(appLang, 107), 
                              message: <><span>{GetLabel(appLang, 536)}</span><br/><span>{GetLabel(appLang, 537)}</span></>
                            });
            return;
        }
        let arr = [];
        for (let i = 0; i < selectedRows.length; i++) {
            arr.push(selectedRows[i].ORDER_ID);
        }
        return (arr);
        if (arr) {
            handleSpreadSheetFetch(arr);
        }
    }

    const generateSpreadsheetDataset = (arr) => {
        if (arr?.length > 0) {
            handleSpreadSheetFetch(arr);
        }
    };    

    const ViewItemReport = (props) => {
        const handleData = async () => {
            hideFilter();
            setDataSet([props.data.ORDER_ID]);
            setScreen(4);
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 576 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
                    </svg>
                </div>
            </>
        );
    };
    
    const ViewItemSpreadSheet = (props) => {
        return(
            <>
                <div 
                    onClick={() => {generateSpreadsheetDataset([props.data.ORDER_ID])}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 24 24"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M9.29289 1.29289C9.48043 1.10536 9.73478 1 10 1H18C19.6569 1 21 2.34315 21 4V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V4C19 3.44772 18.5523 3 18 3H11V8C11 8.55228 10.5523 9 10 9H5V20C5 20.5523 5.44772 21 6 21H7C7.55228 21 8 21.4477 8 22C8 22.5523 7.55228 23 7 23H6C4.34315 23 3 21.6569 3 20V8C3 7.73478 3.10536 7.48043 3.29289 7.29289L9.29289 1.29289ZM6.41421 7H9V4.41421L6.41421 7ZM19 12C19.5523 12 20 12.4477 20 13V19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21H19C18.4477 21 18 20.5523 18 20V13C18 12.4477 18.4477 12 19 12ZM11.8137 12.4188C11.4927 11.9693 10.8682 11.8653 10.4188 12.1863C9.96935 12.5073 9.86526 13.1318 10.1863 13.5812L12.2711 16.5L10.1863 19.4188C9.86526 19.8682 9.96935 20.4927 10.4188 20.8137C10.8682 21.1347 11.4927 21.0307 11.8137 20.5812L13.5 18.2205L15.1863 20.5812C15.5073 21.0307 16.1318 21.1347 16.5812 20.8137C17.0307 20.4927 17.1347 19.8682 16.8137 19.4188L14.7289 16.5L16.8137 13.5812C17.1347 13.1318 17.0307 12.5073 16.5812 12.1863C16.1318 11.8653 15.5073 11.9693 15.1863 12.4188L13.5 14.7795L11.8137 12.4188Z"/>
                    </svg>
                </div>
            </>
        );
    };

    const ViewItem = (props) => {
        const handleData = async () => {
            hideFilter();
            setDataSet([props.data.ORDER_ID]);
            setScreen(5);
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 576 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
                    </svg>
                </div>
            </>
        );
    };

    const DateLabel = ({...other}) => {
        const { status, dt0, dt1 } = other;
        let c = dayjs();
        let i = DateFromIsoString(dt0);
        let f = DateFromIsoString(dt1);
        let style = [MainStyle.border, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center, MainStyle.rounded_3];
        let label = "";
        if (status === 5) {
            style.push(MainStyle.bg_success, MainStyle.text_white);
            label = GetLabel(appLang, 97);
        }
        else {
            if ((c > i) && (c < f)) {
                style.push(MainStyle.bg_warning, MainStyle.text_black);
                label = GetLabel(appLang, 526);
            }
            else if ((c > i) && (c > f)) {
                style.push(MainStyle.bg_success, MainStyle.text_white);
                label = GetLabel(appLang, 98);
            }
            else {
                style.push(MainStyle.bg_success, MainStyle.text_white);
                label = GetLabel(appLang, 99);
            }
        }
        return (
            <div style={{width: '5.0rem'}} className={style.join(" ")}>
                <span className={[MainStyle.fs_7, MainStyle.p_1].join(" ")}>
                    {label}
                </span>
            </div>
        );
    };

    const TagItem = (props) => {
        return(
            <div className={[MainStyle.d_flex, MainStyle.align_items_center].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 576 512"
                    className={[MainStyle.small_ico_generic].join(" ")}
                >
                    <path style={{fill: props?.data !== null? props.data.TAG_COLOR : '#fff' }} d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                </svg>
                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                    {props?.data !== null? props.data.TAG_DESC : ""}
                </span>                
            </div>
        );
    };

    const defaultCol = [
        {
            headerName: GetLabel(appLang, 571),
            marryChildren: true,
            children: [
                DavidCopperfield(12,89,2) && {
                    headerName: GetLabel(appLang, 527),
                    field: 'ORDER_ID',
                    cellRenderer: ViewItemReport,
                    width: 100,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
                DavidCopperfield(12,89,2) && {
                    columnGroupShow: 'open', 
                    headerName: GetLabel(appLang, 539),
                    field: 'ORDER_ID',
                    cellRenderer: ViewItemSpreadSheet,
                    width: 100,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
            ]
        },
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 36),   field: "ORDER_DESC"   ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 321),  field: "PROGRAM_DESC" ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: GetLabel(appLang, 564),  field: "CLASS"        ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: GetLabel(appLang, 37),
                    field: 'OPENING',
                    filter: false,
                    flex: 0,
                    cellRenderer: (params) => {
                        return (
                        <DateLabel
                            status={params.data?.STATUS_ID}
                            dt0={params.data?.OPENING}
                            dt1={params.data?.CLOSING}
                        />
                        );
                    },
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 140,
                },
                { headerName: GetLabel(appLang, 528),  field: "SUBMISSIONS"  ,filter: true , flex: 0, cellStyle: {}, width: 140, cellClass: [MainStyle.table_text_center].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 318),  field: "SCHOOL_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 319),  field: "AREA_DESC"    ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 322),  field: "CLIENT_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 542),  field: "ORDER_USERS"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,        
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 323),  field: "ACADEMIC_AREAS_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                                
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 34),   field: "ORDER_ID"     ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,                
            ]
        },
        {
            headerName: GetLabel(appLang, 574),
            marryChildren: true,
            children: [       
                { headerName: GetLabel(appLang, 38),   field: "OPENING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 39),   field: "CLOSING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                DavidCopperfield(12,89,2) && {
                    columnGroupShow: 'open', 
                    headerName: GetLabel(appLang, 489),
                    field: 'ORDER_ID',
                    cellRenderer: ViewItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
            ]
        },
        {
            headerName: GetLabel(appLang, 575),
            marryChildren: true,
            children: [
                {
                    headerName: GetLabel(appLang, 540),
                    field: 'ORDER_ID',
                    cellRenderer:  (params) => {
                        return (
                            <OpenTag 
                                props={params}
                                setOrderIdTag={setOrderIdTag}
                                setTagPosition={setTagPosition}
                                setTagVisible={setTagVisible}
                            />
                        )
                    },
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
                {
                    headerName: GetLabel(appLang, 541),
                    field: 'TAG_DESC',
                    cellRenderer:  TagItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
            ]
        },        
    ].filter(Boolean);

    useEffect(() => {
        async function getUserTags() {
            try {
                let dataSet = await getUserTag();
                if (dataSet) {
                    if (dataSet?.status?.statusCode === 0) {
                        if (dataSet?.response?.content) {
                            dataSet = dataSet.response.content;
                            let renderedElements = [];
                            for (var i = 0; i < dataSet.length; i++) {
                            renderedElements.push(
                                <Tag
                                    key={dataSet[i].TAG_ID}
                                    tagId={dataSet[i].TAG_ID}
                                    tagColor={dataSet[i].TAG_COLOR}
                                    tagDesc={dataSet[i].TAG_DESC}
                                    setTagVisible={setTagVisible}
                                    orderIdTag={orderIdTag}
                                    setRowData={setRowData}
                                />
                            );
                            }
                            setTagDataset(dataSet);
                        }
                    }
                }
            } 
            catch (error) {
                console.error(error);
            }
        }
        if (searchMetaParam) {
            getUserTags();
            setcolumnDefs(defaultCol);
            showFilter({jsx: 
                            <FilterOptions 
                                setRowData={setRowData} 
                                searchMetaParam={searchMetaParam}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                            />
            });
        }        
    },[searchMetaParam, searchParam, rowData, orderIdTag]);

    return (
        <React.Fragment>
            <TagPanel 
                tagDataset={tagDataset}
                tagVisible={tagVisible} 
                setTagVisible={setTagVisible} 
                tagPosition={tagPosition} 
                orderIdTag={orderIdTag}
                setRowData={setRowData}
            />
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    {(searchParam?.DT_INIT && searchParam?.DT_FN) && (
                        <React.Fragment>
                            <div className={[MainStyle.d_flex, MainStyle.align_items_center].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_5].join(" ")}>
                                    {GetLabel(appLang, 588)}
                                </span>    
                                <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.mx_3].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 589)});}}>
                                    <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                    </svg>
                                </div>
                            </div>
                            <div className={[MainStyle.d_flex, MainStyle.align_items_center].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_5].join(" ")}>
                                    {DateToString({displayTime: false, date: DateFromIsoString(searchParam.DT_INIT)})}   -   {DateToString({displayTime: false, date: DateFromIsoString(searchParam.DT_FN)})}
                                </span>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(12,89,2) && (
                        <div className={[MainStyle.m_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={() => {
                                    generateSpreadsheetDataset(getSelectedRows());
                                }}
                            >
                                {GetLabel(appLang, 627)}
                            </button>
                        </div>
                    )}                    
                </div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(12,89,2) && (
                        <div className={[MainStyle.m_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={() => {
                                    searchDataset(1);
                                }}
                            >
                                {GetLabel(appLang, 544)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <DefaultPadding/>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_9}></div>
                        <div className={MainStyle.col_lg_3}>
                            <div className={[MainStyle.d_flex].join(" ")}>
                                <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        viewBox="0 0 512 512"
                                        className={MainStyle.small_ico_search_bar}
                                    >
                                        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                    </svg>
                                </div>
                                <InputGeneral 
                                    value={searchText}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                    onChange={onQuickFilterChanged}
                                    placeholder={GetLabel(appLang, 33)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ height: '40rem'}}>
                    <AgGridReact 
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        gridOptions={gridOptions}
                        quickFilterText={searchText}
                    />
                </div>
            </div>
        </React.Fragment>
    );
});

export const Report_0_Page = () => {
    const [ screenType,     setScreenType       ]   = useState(1);
    const [ orderId,        setOrderId          ]   = useState(0);
    const [ reportDataSet,  setReportDataSet    ]   = useState([]);
    const navigate                                  = useNavigate();
    const [ searchParam, setSearchParam         ]   = useState(blank_search_param_obj);
    const [ searchMetaParam, setSearchMetaParam ]   = useState(null);
    const [ rowData,     setRowData             ]   = useState([]);      // State of rows def 
    const { showLoader, hideLoader              }   = useLoader();       // Control over the
    const { showInfoMessage                     }   = useInfoMsgModal(); // Modal message control 
    const { hideFilter                          }   = useFilter();       // Control over the loader
    

    useEffect(() => {
        if (!Heimdall([12])) {
            navigate('/home');
        }
        else {
            SetLastFeature(12);
        }        
        if (screenType === 4) {
            hideFilter();
        }
        const fetchFilterData = async () => {
            let data = await getFilterMeta();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setSearchMetaParam(data);
                }
                else {
                    setSearchMetaParam(blank_meta_param_obj);
                }
            }
            else {
                setSearchMetaParam(blank_meta_param_obj);
            }
        };
        const fetchGridData = async () => {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getOrdersList(blank_search_param_obj);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let arr = [];
                    for(var j = 0; j < data.length; j++) {
                        arr.push(data[j]);
                    }
                    setRowData(arr);
                    hideLoader();
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        };
        fetchFilterData();
        fetchGridData();
    }, [screenType, reportDataSet, orderId]);
    
    const ExitWrapper = ({children, onClick }) => {
        return(
            <div style={{   position: 'fixed', 
                            bottom: '0', 
                            //marginBottom: '1rem', 
                            cursor: 'pointer', 
                            zIndex: '10',
                            width: '100%'
                        }}
                  onClick={onClick}
            >
                {children}
            </div>
        );
    };
    const ExitContent = () => {
        return (
            <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_center, MainStyle.shadow, MainStyle.border, MainStyle.bg_card_item].join(" ")}>
                <svg viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg" 
                        className={[MainStyle.small_ico_person_door, MainStyle.m_2].join(" ")}
                >
                    <path d="M355.022,115.897c22.422,0,40.603-18.19,40.603-40.616c0-22.427-18.181-40.608-40.603-40.608 c-22.434,0-40.616,18.182-40.616,40.608C314.406,97.707,332.588,115.897,355.022,115.897z"/>
                    <path d="M509.402,232.445l-26.925-40.501c-6.543-9.57-15.22-17.486-25.33-23.155l-52.81-29.574 c-9.676-4.524-16.996-7.402-26.189-6.159l-25.268,3.436c-9.422,1.275-18.01,6.077-24.037,13.429l-48.096,51.183l-44.055,16.244 c-8.346,3.075-12.825,12.137-10.186,20.627l0.204,0.654c2.593,8.358,11.196,13.29,19.715,11.327l35.901-8.284 c8.952-2.07,17.458-5.758,25.072-10.894l24.97-16.783l8.816,67.033c0.647,4.916-0.343,9.913-2.822,14.214l-74.758,129.848 c-5.333,9.242-2.176,21.068,7.05,26.45l0.642,0.376c8.735,5.087,19.908,2.633,25.69-5.643l83.558-119.534l25.322,50.537 c1.873,3.738,4.351,7.132,7.336,10.044l56.164,54.92c7.091,6.928,18.305,7.23,25.747,0.712l0.9-0.786 c3.819-3.345,6.134-8.073,6.436-13.135c0.302-5.055-1.431-10.036-4.826-13.806l-47.421-52.818L424.44,269.16l-0.09,0.082 l-7.394-72.947l26.115,11.753l41.752,43.945c5.251,5.537,13.757,6.429,20.038,2.094l0.426-0.295 C512.256,248.999,514.096,239.495,509.402,232.445z"></path> 
                    <polygon points="129.123,101.06 43.287,42.435 262.74,42.435 262.74,8.934 0,8.934 0,444.44 43.287,444.44 129.123,503.066 129.123,486.315 129.123,444.44 233.8,444.44 233.8,410.94 129.123,410.94"/>
                </svg>
                <span className={[  MainStyle.fs_5,
                                    MainStyle.text_body  ].join(" ")}>
                    {GetLabel(null, 168)}
                </span>   
            </div>
        );
    };

    return (
        <React.Fragment>
        {
        screenType == 1? 
            <React.Fragment>
                <DefaultPadding/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_12}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <OrderTableGrid 
                                rowData={rowData}
                                setRowData={setRowData}
                                searchMetaParam={searchMetaParam}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                setScreen={setScreenType} 
                                setDataSet={setReportDataSet}
                                setOrderId={setOrderId}
                            />
                        </div>
                    </div>
                </div>
                <DefaultPadding/>
            </React.Fragment>
        :
        screenType == 3? 
            <React.Fragment>
                <ExitWrapper onClick={() => { setScreenType(1); }}>
                    <ExitContent/>
                </ExitWrapper>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_12}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <OrderDocumentPreview orderId={orderId}/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        :
        screenType == 4? 
            <React.Fragment>
                <ExitWrapper onClick={() => { setScreenType(1); }}>
                    <ExitContent/>
                </ExitWrapper>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_12}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <AggregatedReportDocument dataSet={reportDataSet}/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        : 
        screenType == 5? 
            <React.Fragment>
                <ExitWrapper onClick={() => { setScreenType(1); }}>
                    <ExitContent/>
                </ExitWrapper>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_12}>
                        <AggregatedReport dataSet={reportDataSet}/>
                    </div>
                </div>
            </React.Fragment>
        : 
            null
        }
        </React.Fragment>
    );
};